import Cookies from "js-cookie";
import axios from "axios";
import i18n from "./i18n";
import { setSecureCookie, clearAuthCookies } from "./utils/cookieUtils";

const apiUrl = process.env.REACT_APP_API_URL;
if (!apiUrl && process.env.NODE_ENV === "production") {
  console.error("REACT_APP_API_URL is not set.");
}
class Api {
  constructor() {
    this.instance = axios.create({
      baseURL: apiUrl,
      headers: this.getRequestHeaders(),
    });

    this.instance.interceptors.request.use(
      (config) => {
        config.headers = this.getRequestHeaders();
        return config;
      },
      (error) => {

        return Promise.reject(error);
      }
    );

    this.instance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;
        const status = error.response?.status;
        if (status === 401 && originalRequest && !originalRequest._retry) {
          originalRequest._retry = true;
          if (!apiUrl) {
            clearAuthCookies();
            return Promise.reject(error);
          }
          try {
            const oldRefreshToken = Cookies.get("RefreshToken");
            const response = await axios.post(`${apiUrl}Auth/refresh-token`, {
              refreshToken: oldRefreshToken,
            });
            const { accessToken, refreshToken, TokenExpiryTime } = response.data?.data ?? {};
            clearAuthCookies();
            setSecureCookie("AccessToken", accessToken);
            setSecureCookie("RefreshToken", refreshToken);
            if (TokenExpiryTime != null) {
              setSecureCookie("ExpiresIn", String(TokenExpiryTime));
            }
            originalRequest.headers.Authorization = `Bearer ${accessToken}`;
            return this.instance(originalRequest);
          } catch (refreshError) {
            clearAuthCookies();
            return Promise.reject(refreshError);
          }
        }
        return Promise.reject(error);
      }
    );

    this.isModalOpen = false;
  }

  getRequestHeaders() {
    return {
      Authorization: `Bearer ${Cookies.get("AccessToken")}`,
      "X-Language": i18n.language || "tr",
      "accept-language": i18n.language || "tr",
    };
  }

  async refreshToken() {
    if (!apiUrl) {
      clearAuthCookies();
      return;
    }
    try {
      const oldRefreshToken = Cookies.get("RefreshToken");
      const response = await axios.post(`${apiUrl}Auth/refresh-token`, {
        refreshToken: oldRefreshToken,
      });
      const { accessToken, refreshToken, TokenExpiryTime } = response.data?.data ?? {};
      clearAuthCookies();
      setSecureCookie("AccessToken", accessToken);
      setSecureCookie("RefreshToken", refreshToken);
      if (TokenExpiryTime != null) {
        setSecureCookie("ExpiresIn", String(TokenExpiryTime));
      }
    } catch (error) {
      clearAuthCookies();
    }
  }
}

const api = new Api().instance;
const refreshToken = Api.prototype.refreshToken;

export { api, refreshToken };
export default api;